import { enumOverrideType } from "../constants";
import type { QObjDBObject } from "../CoreApp/QObjDBObject";
import type { QPlanManager } from "../CoreApp/QPlanManager";

// The gear ("reopen the existing change") action reuses this predicate under a key
// that is deliberately not an enumOverrideType member.
export const kModifyOverride = "Modify";

export function IsValidPlanOverride(
  planMgr: QPlanManager,
  dbObj: QObjDBObject,
  overrideType: string
): boolean {
  const planTopObj = planMgr.GetTopObjRef();
  const targetObjID = dbObj.GetObjectRecordID();
  const isAuxInstance = (dbObj.SmartGetFieldValue("isAux") as number) > 0;
  const coHeadIDs = planMgr.GetCoHeadIDs();
  const isPlanTopBox =
    planTopObj?.GetObjectRecordID() === targetObjID || coHeadIDs.indexOf(targetObjID) > -1;

  const activeOverrideObj = planMgr.GetActiveOverrideObj(dbObj);
  let changeType: string | null = null;
  let isReverted = true;
  let isConflicted = false;
  if (activeOverrideObj) {
    changeType = activeOverrideObj.SmartGetFieldValue("Type") as string;
    const lastActive = activeOverrideObj.lastActiveChange(activeOverrideObj);
    if (lastActive && lastActive.fConflict == true) isConflicted = true;
    isReverted = false;
  }

  // "Standard" terminology is unique to this area
  const hasStandardOverrideChangeType =
    changeType &&
    [
      enumOverrideType.add,
      enumOverrideType.change,
      enumOverrideType.move,
      enumOverrideType.comment
    ].includes(changeType);

  const blockedByExistingChange = !!changeType && !hasStandardOverrideChangeType && !isReverted;
  // OCN5-3584 (temporary, slated for removal): an active Add change hides move-out and delete.
  const activeChangeIsAdd = changeType === enumOverrideType.add;

  switch (overrideType) {
    case enumOverrideType.change:
      return !(blockedByExistingChange && !isConflicted);
    case enumOverrideType.move:
      return !(isPlanTopBox || isAuxInstance || blockedByExistingChange);
    case enumOverrideType.add:
      return !(isAuxInstance || blockedByExistingChange);
    case enumOverrideType.delete:
      return !(isPlanTopBox || blockedByExistingChange || activeChangeIsAdd);
    case enumOverrideType.comment:
      return true;
    case enumOverrideType.moveout:
      return !(isPlanTopBox || isAuxInstance || blockedByExistingChange || activeChangeIsAdd);
    case kModifyOverride:
      return !(!changeType || isReverted || isConflicted);
    default:
      return true;
  }
}
